import { GOI_SERVICE_URL } from "@/constants/url";
import { NextLink, VStack, colors } from "goi_common";
import ReviewStarList from "./ReviewStarList";
import { Review } from "@/types/reviewType";
import dayjs from "dayjs";

interface Props {
  review: Review;
}

const ReviewItem = ({ review }: Props) => {
  return (
    <li
      css={{
        padding: "16px 0",
        borderTop: `1px solid ${colors.gray600}`,
      }}
      className="gray200"
    >
      <NextLink href={`${GOI_SERVICE_URL}/review/${review.id}`}>
        <VStack>
          <span className="subtitle_14_b">
            {dayjs(review.created_at, "YYYY-MM-DD").format("YYYY-MM-DD")}
          </span>
          <p
            className="body_14_m"
            css={{
              margin: "4px 0 12px",
              WebkitLineClamp: 4,
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              height: "88px",
              textOverflow: "ellipsis",
            }}
          >
            {review.good}
          </p>
          <ReviewStarList score={review.score} />
        </VStack>
      </NextLink>
    </li>
  );
};

export default ReviewItem;
